export {Clock as ClockComponent} from '../../components/hocs/Clock';



// WEBPACK FOOTER //
// ./src/js/core-components/clock/index.js